
import { rightSidePanelDetails } from "../../models/model";
import { ChatRightWindowActions } from "../interface/reducerType";

import {Types} from '../action/action';

const initialState=  {

  isLink: false,
  linkListDetails: [],
  isNotes:false,
  isNotesLoader:true,
  notesListDetails: [],
  notesDefaultCount: 0,
  isTask: false,
  taskListDetails: [],
  taskDefaultCount: 0,
  isEvent:false,
  eventListDetails:[],
  isSavedList: false,
  savedListDetails: [],
  fileListDetails:[],
  isfile:false,
  ischatfileLoad:false,
  chatfileLength:0,
  ischatfileStopPagination:true,
  taskLoader:true,
  eventLoader:true
};



export const chatRightSidePanelReducer = (state: rightSidePanelDetails = initialState,
  action: ChatRightWindowActions) => {
  switch (action.type) {

  case Types.GET_LINK_LIST:
    return {
      ...state, isLink: action.payload.isLink, linkListDetails: action.payload.linkListDetails
    };
  case Types.GET_NOTES_LIST:
    return {
      ...state,isNotesLoader:action.payload.isNotesLoader, isNotes: action.payload.isNotes, notesListDetails: action.payload.notesListDetails,
      notesDefaultCount: action.payload.notesDefaultCount
    };
  case Types.GET_TASK_LIST:
    return {
      ...state, isTask: action.payload.isTask, taskListDetails: action.payload.taskListDetails,
      taskDefaultCount: action.payload.taskDefaultCount,taskLoader:action.payload.taskLoader
    };
  case Types.GET_EVENT_LIST:
    return {
      ...state, isEvent: action.payload.isEvent,eventLoader:action.payload.eventLoader, eventListDetails: action.payload.eventListDetails
    };
  case Types.GET_FILES_LIST:
    return {
      ...state, isfile: action.payload.isfile, fileListDetails: action.payload.fileListDetails
    };
  case Types.CHAT_FILE_LOAD:
    return {
      ...state, ischatfileLoad: action.payload.ischatfileLoad,
      ischatfileStopPagination: action.payload.ischatfileStopPagination,
      chatfileLength: action.payload.chatfileLength
    };
    
  case Types.GET_SAVED_LIST:
    return {
      ...state, isSavedList: action.payload.isSavedList, savedListDetails: action.payload.savedListDetails
    };

  default:
    return state;
  }
};